<template>
    <div class="semi-process-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div class="page-header__left">
                <i class="el-icon-folder-opened page-header__icon"></i>
                <h2 class="page-header__title">半流程-项目管理</h2>
            </div>
            <el-button type="primary" icon="el-icon-plus" @click="handleAddProject">新增项目</el-button>
        </div>

        <!-- 项目列表 -->
        <div class="project-list-wrap">
            <div class="list-header">
                <div class="list-header__left">
                    <span class="list-title">项目列表</span>
                    <span class="list-total">共 {{ query.total }} 条</span>
                </div>
            </div>

            <el-table 
                :data="tableData" 
                border 
                v-loading="loading" 
                stripe
                class="project-table"
            >
                <el-table-column type="index" label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        {{ (query.page - 1) * query.pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="项目名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="project-name">
                            <i class="el-icon-document"></i>
                            <span>{{ scope.row.projectName }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="sectionCount" label="标段数量" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small" type="info">{{ scope.row.sectionCount }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="totalTenderFee" label="标书款(元)" width="130" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.totalTenderFee || '0.00' }}
                    </template>
                </el-table-column>
                <el-table-column prop="totalDrawingDepositFee" label="图纸押金(元)" width="130" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.totalDrawingDepositFee || '0.00' }}
                    </template>
                </el-table-column>
                <el-table-column label="招标文件" width="120" align="center">
                    <template slot-scope="scope">
                        <span :class="scope.row.hasTenderFile === 1 ? 'tag-yes' : 'tag-no'">
                            {{ scope.row.hasTenderFile === 1 ? '有' : '无' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <span :class="scope.row.status === 1 ? 'status-submit' : 'status-draft'">
                            {{ scope.row.status === 1 ? '已提交' : '暂存' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="170" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.createTime }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleDetail(scope.row)">查看</el-button>
                        <el-button 
                            type="text" 
                            size="small" 
                            @click="handleEnterFlow(scope.row)" 
                            v-if="scope.row.status == 1"
                        >
                            进入流程
                        </el-button>
                        <el-button 
                            type="text" 
                            size="small" 
                            style="color: #F56C6C;" 
                            @click="handleDelete(scope.row)" 
                            v-if="scope.row.status == 0"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-box">
                <el-pagination
                    @current-change="handlePageChange"
                    :current-page="query.page"
                    :page-size="query.pageSize"
                    :total="query.total"
                    layout="total, prev, pager, next, jumper"
                    background
                />
            </div>

            <!-- 空状态 -->
            <div class="empty-placeholder" v-if="!loading && tableData.length === 0">
                <i class="el-icon-document-remove"></i>
                <p>暂无项目，点击右上角创建</p>
            </div>
        </div>
    </div>
</template>

<script>
import { Api_GetSemiProcessProjectList, Api_DeleteSemiProcessProject } from '@/api/modules/semiProcess'

export default {
    name: 'SemiProcessIndex',

    data() {
        return {
            loading: false,
            query: {
                page: 1,
                pageSize: 10,
                projectName: '',
                total: 0
            },
            tableData: []
        }
    },

    mounted() {
        this.fetchList()
    },

    methods: {
        async fetchList() {
            this.loading = true
            try {
                const res = await Api_GetSemiProcessProjectList(this.query)
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.query.page = res.data.current || 1
                    this.query.pageSize = res.data.size || 10
                    this.query.total = res.data.total || 0
                } else {
                    this.$message.warning(res.msg || '获取列表失败')
                }
            } catch (err) {
                console.warn('请求异常:', err)
                this.$message.error('网络异常，请稍后重试')
            } finally {
                this.loading = false
            }
        },

        handlePageChange(page) {
            this.query.page = page
            this.fetchList()
        },

        handleAddProject() {
            this.$router.push('/agentHome/addProject')
        },

        handleDetail(row) {
            this.$router.push({
                path: '/agentHome/addProject',
                query: { projectCode: row.projectCode }
            })
        },

        handleEnterFlow(row) {
            this.$router.push({
                path: '/agentHome/projectWorkflow',
                query: {
                    projectName: row.projectName,
                    projectCode: row.projectCode || 'E1101050893002128'
                }
            })
        },

        handleDelete(row) {
            this.$confirm(`确认删除项目「${row.projectName}」吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await Api_DeleteSemiProcessProject(row.projectCode)
                    if (res.code === 200) {
                        this.$message.success('已删除')
                        this.fetchList()
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                } catch (err) {
                    this.$message.error('删除失败，请重试')
                }
            }).catch(() => {})
        }
    }
}
</script>

<style lang="less" scoped>
.semi-process-page {
    padding: 20px;
    background: #f0f2f5;
    min-height: calc(100vh - 130px)
}

/* 页面头部 */
.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 16px 24px;
    border-radius: 6px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.page-header__left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.page-header__icon {
    font-size: 20px;
    color: #409EFF;
}

.page-header__title {
    font-size: 17px;
    font-weight: 600;
    color: #303133;
    margin: 0;
}

/* 列表容器 */
.project-list-wrap {
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    overflow: hidden;
}

.list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 24px;
    border-bottom: 1px solid #ebeef5;
}

.list-header__left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.list-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.list-total {
    font-size: 13px;
    color: #909399;
    background: #f4f4f5;
    padding: 0 10px;
    border-radius: 10px;
    line-height: 22px;
}

/* 表格 */
.project-table {
    /deep/ .el-table__header th {
        background: #fafafa;
        color: #606266;
        font-weight: 600;
        font-size: 13px;
        padding: 12px 0;
    }

    /deep/ .el-table__body td {
        padding: 14px 0;
        font-size: 13px;
        color: #606266;
    }

    /deep/ .el-table__row--striped td {
        background: #fafafa;
    }

    /deep/ .el-table__row:hover td {
        background: #f5f7fa;
    }
}

.project-name {
    display: flex;
    align-items: center;
    gap: 6px;
    
    i {
        color: #409EFF;
        font-size: 15px;
    }
}

/* 标签 */
.tag-yes {
    display: inline-block;
    padding: 0 10px;
    line-height: 24px;
    font-size: 12px;
    border-radius: 3px;
    background: #f0f9eb;
    color: #67c23a;
    border: 1px solid #c2e7b0;
}

.tag-no {
    display: inline-block;
    padding: 0 10px;
    line-height: 24px;
    font-size: 12px;
    border-radius: 3px;
    background: #f5f5f5;
    color: #909399;
    border: 1px solid #e4e7ed;
}

.status-submit {
    display: inline-block;
    padding: 0 10px;
    line-height: 24px;
    font-size: 12px;
    border-radius: 3px;
    background: #f0f9eb;
    color: #67c23a;
}

.status-draft {
    display: inline-block;
    padding: 0 10px;
    line-height: 24px;
    font-size: 12px;
    border-radius: 3px;
    background: #fdf6ec;
    color: #e6a23c;
}

/* 分页 */
.pagination-box {
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid #ebeef5;
}

/* 空状态 */
.empty-placeholder {
    text-align: center;
    padding: 60px 0;
    color: #909399;

    i {
        font-size: 50px;
        display: block;
        margin-bottom: 12px;
        color: #dcdfe6;
    }

    p {
        font-size: 14px;
        margin: 0;
    }
}
</style>